import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, vShow as _vShow, withDirectives as _withDirectives, Teleport as _Teleport, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6d346e11"),n=n(),_popScopeId(),n)
const _hoisted_1 = { href: "#login" }
const _hoisted_2 = {
  key: 5,
  class: "register-business-form__header"
}
const _hoisted_3 = {
  key: 17,
  class: "text-input__error-message text-input__error-message--global"
}
const _hoisted_4 = ["disabled"]
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { href: "" }

import { computed, PropType, ref, watch } from "vue";
import { useI18n } from "vue-i18n";
import dictionary from "@/i18n/dictionary.json";
import { CustomerNumberValidatorResult, EmailValidatorResult, RegisterAccountBusiness } from "@/models/AccountRegister";
import TressTextInput from "@/components/TressTextInput.vue";
import { MemberApi } from "@/services/Api";
import { Validator } from "@/code/Validator";
import { defineRule } from "vee-validate";
import TressException from "@/services/TressException";
import { TressExceptions } from "@/code/TressExceptions";
import TressAlert from "@/components/TressAlert.vue";
import TressFormSuccess from "@/components/TressFormSuccess.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'TressAccountRegisterBusinessForm',
  props: {
  modelValue: {
    type: Object as PropType<RegisterAccountBusiness>,
    default: () => ({}),
  },
},
  emits: ["update:modelValue", "onCreate", "onValidateEmail", "onValidateCustomerNumber", "success"],
  setup(__props, { emit }) {

const $t = useI18n().t;


const lang = (document.documentElement as HTMLHtmlElement).lang;
const form = ref();
const isSending = ref<boolean>(false);
const hideCustomerInputs = ref<boolean>(false);
const hasSuccess = ref<boolean>(false);
const userAlreadyExists = ref<boolean>(false);
const migrationUserExists = ref<boolean>(false);
const customerNumberResult = ref<CustomerNumberValidatorResult>();
const queryParams = new URLSearchParams(window.location.search);
const returnUrl = ref(queryParams.get("returnUrl"));


const register = ref<RegisterAccountBusiness>({} as RegisterAccountBusiness);

const validateCustomerNumber = async (customerNumber: string) => {
  try {
    const result = await MemberApi.validateCustomerNumber(customerNumber);
    if (result.success) {
      hideCustomerInputs.value = true;
      customerNumberResult.value = result;
    } else {
      hideCustomerInputs.value = false;
      customerNumberResult.value = undefined;
    }
  } catch {
    hideCustomerInputs.value = false;
    customerNumberResult.value = undefined;
  }
  return true;
};
defineRule("validateCustomerNumber", validateCustomerNumber);
const onSubmit = async (values) => {
  try {
    isSending.value = true;

    if (migrationUserExists.value) {
      hasSuccess.value = await MemberApi.migrateAccount(register.value.email, register.value.name, "business");
      emit("success");
    } else {
      values.type = "business";
      hasSuccess.value = await MemberApi.registerAccountBusiness(values);
      emit("success");
      setTimeout(() => {
        if (returnUrl.value) {
          window.location.href = returnUrl.value;
        }
      }, 30000);
    }
  } catch (e: unknown) {
    switch (TressException(e)) {
      case TressExceptions.Register_AlreadyLoggedIn:
        form.value.setFieldError("", $t(dictionary.form.error.alreadyLoggedIn));
        break;
      case TressExceptions.Register_EmailAlreadyExists:
        form.value.setFieldError("email", $t(dictionary.form.error.emailAlreadyExists));
        break;
      case TressExceptions.Register_InvalidMailAddress:
        form.value.setFieldError("email", $t(dictionary.form.error.invalidMailAddress));
        break;
      case TressExceptions.Register_InvalidPassword:
        form.value.setFieldError("password", $t(dictionary.form.error.invalidPassword));
        break;
      case TressExceptions.Register_MissingCustomerAddress:
        form.value.setFieldError("customerAddress", $t(dictionary.form.error.missingCustomerAddress));
        break;
      case TressExceptions.Register_MissingCustomerCity:
        form.value.setFieldError("customerCity", $t(dictionary.form.error.missingCustomerCity));
        break;
      case TressExceptions.Register_MissingCustomerEmail:
        form.value.setFieldError("customerEmail", $t(dictionary.form.error.missingCustomerEmail));
        break;
      case TressExceptions.Register_MissingCustomerName:
        form.value.setFieldError("customerName", $t(dictionary.form.error.missingCustomerName));
        break;
      case TressExceptions.Register_MissingCustomerForCustomerNumber:
        form.value.setFieldError("customerNumber", $t(dictionary.form.error.missingCustomerNumber));
        break;
      case TressExceptions.Register_MissingCustomerPhoneNumber:
        form.value.setFieldError("customerPhoneNumber", $t(dictionary.form.error.missingCustomerPhoneNumber));
        break;
      case TressExceptions.Register_MissingCustomerZip:
        form.value.setFieldError("customerPostalCode", $t(dictionary.form.error.missingCustomerZip));
        break;
      case TressExceptions.Register_MissingName:
        form.value.setFieldError("name", $t(dictionary.form.error.missingName));
        break;
      case TressExceptions.Register_MissingPhoneNumber:
        form.value.setFieldError("phoneNumber", $t(dictionary.form.error.missingPhoneNumber));
        break;
      case TressExceptions.Register_PasswordsMustMatch:
        form.value.setFieldError("password2", $t(dictionary.form.error.passwordMustMatch));
        break;
      case TressExceptions.Unknown_Error:
        form.value.setFieldError("", $t(dictionary.form.error.unknownError));
        break;
    }
  } finally {
    isSending.value = false;
  }
};
watch(
  () => register.value.email,
  async (currVal) => {
    const validationResult = await Validator.emailValidate(currVal);
    if (Number(EmailValidatorResult[validationResult]) == EmailValidatorResult.UmbracoUserExists) {
      userAlreadyExists.value = true;
    } else if (Number(EmailValidatorResult[validationResult]) == EmailValidatorResult.MigrationUserExists) {
      migrationUserExists.value = true;
    }
  }
);
const newRegistration = computed(() => {
  return !migrationUserExists.value;
});
const submitButtonText = computed(() => {
  if (migrationUserExists.value) {
    return $t(dictionary.account.migrateAccount);
  } else {
    return $t(dictionary.account.createAccount);
  }
});

return (_ctx: any,_cache: any) => {
  const _component_v_field = _resolveComponent("v-field")!
  const _component_v_form = _resolveComponent("v-form")!

  return (!hasSuccess.value)
    ? (_openBlock(), _createBlock(_component_v_form, {
        key: 0,
        ref_key: "form",
        ref: form,
        class: "register-business-form",
        onSubmit: onSubmit
      }, {
        default: _withCtx(({ errors }) => [
          _createVNode(TressTextInput, {
            modelValue: register.value.name,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((register.value.name) = $event)),
            label: _unref($t)(_unref(dictionary).form.name.label),
            name: "name",
            rules: "required"
          }, {
            label: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref($t)(_unref(dictionary).form.name.label)), 1)
            ]),
            _: 1
          }, 8, ["modelValue", "label"]),
          _createVNode(TressTextInput, {
            modelValue: register.value.email,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((register.value.email) = $event)),
            label: _unref($t)(_unref(dictionary).form.email.label),
            name: "email",
            rules: "required|email"
          }, {
            label: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref($t)(_unref(dictionary).form.email.label)), 1)
            ]),
            _: 1
          }, 8, ["modelValue", "label"]),
          (userAlreadyExists.value)
            ? (_openBlock(), _createBlock(TressAlert, {
                key: 0,
                success: true
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref($t)(_unref(dictionary).form.alreadyHaveAnAccount)) + " ", 1),
                  _createElementVNode("a", _hoisted_1, _toDisplayString(_unref($t)(_unref(dictionary).form.loginHere)), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (migrationUserExists.value)
            ? (_openBlock(), _createBlock(TressAlert, {
                key: 1,
                success: true
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref($t)(_unref(dictionary).form.migrationUserExists)), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (newRegistration.value)
            ? (_openBlock(), _createBlock(TressTextInput, {
                key: 2,
                modelValue: register.value.phoneNumber,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((register.value.phoneNumber) = $event)),
                label: _unref($t)(_unref(dictionary).form.phoneNumber.label),
                name: "phoneNumber",
                rules: { required: true, regex: /^\d*$/ }
              }, {
                label: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref($t)(_unref(dictionary).form.phoneNumber.placeholder)), 1)
                ]),
                _: 1
              }, 8, ["modelValue", "label"]))
            : _createCommentVNode("", true),
          (newRegistration.value)
            ? (_openBlock(), _createBlock(TressTextInput, {
                key: 3,
                modelValue: register.value.password,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((register.value.password) = $event)),
                label: _unref($t)(_unref(dictionary).form.password.label),
                name: "password",
                rules: "required",
                type: "password"
              }, {
                label: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref($t)(_unref(dictionary).form.password.label)), 1)
                ]),
                _: 1
              }, 8, ["modelValue", "label"]))
            : _createCommentVNode("", true),
          (newRegistration.value)
            ? (_openBlock(), _createBlock(TressTextInput, {
                key: 4,
                modelValue: register.value.password2,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((register.value.password2) = $event)),
                label: _unref($t)(_unref(dictionary).form.password2.label),
                name: "password2",
                rules: "required|confirmed:@password",
                type: "password"
              }, {
                label: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref($t)(_unref(dictionary).form.password2.label)), 1)
                ]),
                _: 1
              }, 8, ["modelValue", "label"]))
            : _createCommentVNode("", true),
          (newRegistration.value)
            ? (_openBlock(), _createElementBlock("h2", _hoisted_2, _toDisplayString(_unref($t)(_unref(dictionary).account.companyDetails)), 1))
            : _createCommentVNode("", true),
          (newRegistration.value)
            ? (_openBlock(), _createBlock(TressTextInput, {
                key: 6,
                modelValue: register.value.customerNumber,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((register.value.customerNumber) = $event)),
                label: _unref($t)(_unref(dictionary).form.customerNumber.label),
                name: "customerNumber",
                rules: "validateCustomerNumber"
              }, {
                label: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref($t)(_unref(dictionary).form.customerNumber.label)), 1)
                ]),
                _: 1
              }, 8, ["modelValue", "label"]))
            : _createCommentVNode("", true),
          (hideCustomerInputs.value)
            ? (_openBlock(), _createBlock(TressAlert, {
                key: 7,
                success: true
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref($t)(_unref(dictionary).form.customerNumberExists, { name: customerNumberResult.value?.name })), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (!hideCustomerInputs.value && newRegistration.value)
            ? (_openBlock(), _createBlock(TressTextInput, {
                key: 8,
                modelValue: register.value.customerName,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((register.value.customerName) = $event)),
                label: _unref($t)(_unref(dictionary).form.customerName.label),
                name: "customerName",
                rules: "required"
              }, {
                label: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref($t)(_unref(dictionary).form.customerName.label)), 1)
                ]),
                _: 1
              }, 8, ["modelValue", "label"]))
            : _createCommentVNode("", true),
          (!hideCustomerInputs.value && newRegistration.value)
            ? (_openBlock(), _createBlock(TressTextInput, {
                key: 9,
                modelValue: register.value.customerEmail,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((register.value.customerEmail) = $event)),
                label: _unref($t)(_unref(dictionary).form.customerEmail.label),
                name: "customerEmail",
                rules: "required"
              }, {
                label: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref($t)(_unref(dictionary).form.customerEmail.label)), 1)
                ]),
                _: 1
              }, 8, ["modelValue", "label"]))
            : _createCommentVNode("", true),
          (!hideCustomerInputs.value && newRegistration.value)
            ? (_openBlock(), _createBlock(TressTextInput, {
                key: 10,
                modelValue: register.value.customerPhoneNumber,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((register.value.customerPhoneNumber) = $event)),
                label: _unref($t)(_unref(dictionary).form.customerPhoneNumber.label),
                name: "customerPhoneNumber",
                rules: { required: true, regex: /^\d*$/ }
              }, {
                label: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref($t)(_unref(dictionary).form.customerPhoneNumber.label)), 1)
                ]),
                _: 1
              }, 8, ["modelValue", "label"]))
            : _createCommentVNode("", true),
          (!hideCustomerInputs.value && newRegistration.value)
            ? (_openBlock(), _createBlock(TressTextInput, {
                key: 11,
                modelValue: register.value.customerAddress,
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((register.value.customerAddress) = $event)),
                label: _unref($t)(_unref(dictionary).form.customerAddress.label),
                name: "customerAddress",
                rules: "required"
              }, {
                label: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref($t)(_unref(dictionary).form.customerAddress.label)), 1)
                ]),
                _: 1
              }, 8, ["modelValue", "label"]))
            : _createCommentVNode("", true),
          (!hideCustomerInputs.value && newRegistration.value)
            ? (_openBlock(), _createBlock(TressTextInput, {
                key: 12,
                modelValue: register.value.customerAddress2,
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((register.value.customerAddress2) = $event)),
                label: _unref($t)(_unref(dictionary).form.customerAddress2.label),
                name: "customerAddress2"
              }, {
                label: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref($t)(_unref(dictionary).form.customerAddress2.label)), 1)
                ]),
                _: 1
              }, 8, ["modelValue", "label"]))
            : _createCommentVNode("", true),
          (!hideCustomerInputs.value && newRegistration.value)
            ? (_openBlock(), _createBlock(TressTextInput, {
                key: 13,
                modelValue: register.value.customerPostalCode,
                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((register.value.customerPostalCode) = $event)),
                label: _unref($t)(_unref(dictionary).form.customerZip.label),
                class: "register-business-form__input register-business-form__input--half",
                name: "customerPostalCode",
                rules: { required: true, regex: _unref(Validator).zipCodeRules() }
              }, {
                label: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref($t)(_unref(dictionary).form.customerZip.label)), 1)
                ]),
                _: 1
              }, 8, ["modelValue", "label", "rules"]))
            : _createCommentVNode("", true),
          (!hideCustomerInputs.value && newRegistration.value)
            ? (_openBlock(), _createBlock(TressTextInput, {
                key: 14,
                modelValue: register.value.customerCity,
                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((register.value.customerCity) = $event)),
                label: _unref($t)(_unref(dictionary).form.customerCity.label),
                class: "register-business-form__input register-business-form__input--half",
                name: "customerCity",
                rules: "required"
              }, {
                label: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref($t)(_unref(dictionary).form.customerCity.label)), 1)
                ]),
                _: 1
              }, 8, ["modelValue", "label"]))
            : _createCommentVNode("", true),
          (!hideCustomerInputs.value && newRegistration.value)
            ? (_openBlock(), _createBlock(TressTextInput, {
                key: 15,
                modelValue: register.value.customerCVR,
                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((register.value.customerCVR) = $event)),
                label: _unref($t)(_unref(dictionary).form.customerCVR.label),
                name: "customerCVR"
              }, {
                label: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref($t)(_unref(dictionary).form.customerCVR.label)), 1)
                ]),
                _: 1
              }, 8, ["modelValue", "label"]))
            : _createCommentVNode("", true),
          (_unref(lang) == 'da' && !hideCustomerInputs.value && newRegistration.value)
            ? (_openBlock(), _createBlock(TressTextInput, {
                key: 16,
                modelValue: register.value.customerEAN,
                "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((register.value.customerEAN) = $event)),
                label: _unref($t)(_unref(dictionary).form.customerEAN.label),
                name: "customerEAN"
              }, {
                label: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref($t)(_unref(dictionary).form.customerEAN.label)), 1)
                ]),
                _: 1
              }, 8, ["modelValue", "label"]))
            : _createCommentVNode("", true),
          _withDirectives(_createVNode(_component_v_field, { name: "" }, null, 512), [
            [_vShow, false]
          ]),
          (errors[''])
            ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(errors[""]), 1))
            : _createCommentVNode("", true),
          _createElementVNode("button", {
            disabled: isSending.value,
            class: "button register-business-form__submit-button"
          }, _toDisplayString(submitButtonText.value), 9, _hoisted_4)
        ]),
        _: 1
      }, 512))
    : (_openBlock(), _createBlock(_Teleport, {
        key: 1,
        to: "#success-container"
      }, [
        _createVNode(TressFormSuccess, null, {
          header: _withCtx(() => [
            (migrationUserExists.value)
              ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_unref($t)(_unref(dictionary).account.migrateAccountSuccessHeader)), 1))
              : (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_unref($t)(_unref(dictionary).account.registerAccountSuccessHeader)), 1))
          ]),
          description: _withCtx(() => [
            (migrationUserExists.value)
              ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_unref($t)(_unref(dictionary).account.migrateAccountSuccessDescription)), 1))
              : (_openBlock(), _createElementBlock("span", _hoisted_8, [
                  _createTextVNode(_toDisplayString(_unref($t)(_unref(dictionary).account.registerAccountSuccessDescription)) + " ", 1),
                  _createElementVNode("a", _hoisted_9, _toDisplayString(_unref($t)(_unref(dictionary).common.clickHere)), 1)
                ]))
          ]),
          _: 1
        })
      ]))
}
}

})